module.exports = __webpack_public_path__ + "img/3d29f6cab0cc3c60e190edf62e25d250.gif";